import { Component, NgZone, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import * as moment from "moment";
import { Subscription } from "rxjs";
import { APIService } from "src/app/api/api.service";
import { NotifierService } from "src/app/_services/notifier.service";
import { environment } from "src/environments/environment";

declare let $: any;
declare let window: any;

@Component({
  selector: "app-azure-billing",
  templateUrl: "./azure-billing.component.html",
  styleUrls: ["./azure-billing.component.css"],
})
export class AzureBillingComponent implements OnInit, OnDestroy {
  userId = localStorage.getItem("selectedClientList");
  subscriptionId = localStorage.getItem("accountId");
  urlPrefix = localStorage.getItem("role") == "Admin" ? "admin" : "client";
  monthYear = moment().format("YYYY-MM");
  loading = true;
  errorMessage: string = null;
  rows: any[] = [];
  private currentMessage: Subscription;

  constructor(
    private apiService: APIService,
    private notifier: NotifierService,
    private zone: NgZone,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      if (!msg) return;

      let d = JSON.parse(msg);
      if (d.value == null || d.source != "notifier") return;

      if (d.key == "accountId") {
        this.subscriptionId = d.value;
        this.load();
      }
    });

    $(".datetimepicker")
      .datepicker({
        autoclose: true,
        minViewMode: 1,
        format: "mm-yyyy",
        orientation: "bottom auto",
        endDate: new Date(),
      })
      .on("changeDate", function (selected: any) {
        $(".datetimepicker").val(
          moment(selected["dates"][0]).format("MM-YYYY")
        );
        window.azureBillingComponentReference.zone.run(() => {
          window.azureBillingComponentReference.componentFn();
        });
      });

    $(".datetimepicker").val(
      moment(this.monthYear, "YYYY-MM").format("MM-YYYY")
    );

    window.azureBillingComponentReference = {
      zone: this.zone,
      componentFn: () => {
        const selectedMonth = $(".datetimepicker").val();
        if (selectedMonth) {
          this.monthYear = moment(selectedMonth, "MM-YYYY").format("YYYY-MM");
        }
        setTimeout(() => {
          this.load();
        }, 100);
      },
      component: this,
    };
  }

  ngOnDestroy(): void {
    if (this.currentMessage) {
      this.currentMessage.unsubscribe();
    }
    if ($(".datetimepicker").data("datepicker")) {
      $(".datetimepicker").datepicker("destroy");
    }
    if (window.azureBillingComponentReference) {
      delete window.azureBillingComponentReference;
    }
  }

  async load() {
    this.notifier.loading(true);
    this.loading = true;
    this.errorMessage = null;
    this.rows = [];

    const data: any = {
      user_id: this.userId,
      subscription_id: this.subscriptionId,
      month_year: this.monthYear,
    };

    const header: any = {
      Authorization: localStorage.getItem("t"),
    };

    const apiUrl =
      `${environment.apiURL}/${this.urlPrefix}/azure/billing/billing` +
      `?user_id=${encodeURIComponent(data.user_id)}` +
      `&subscription_id=${encodeURIComponent(data.subscription_id)}` +
      `&month_year=${encodeURIComponent(data.month_year)}`;

    const result: any = await this.apiService.getDataPromis(apiUrl, {}, header);

    if (Array.isArray(result?.items)) {
      this.rows = result.items;
    } else if (result?.subscription_id) {
      this.rows = [result];
    } else {
      this.errorMessage =
        result?.error_message || result?.message || "Unable to load Azure billing.";
      this.notifier.alert("Error", "", this.errorMessage, "error", 5000);
    }

    this.loading = false;
    this.notifier.loading(false);
  }

  openResourceGroups(row: any) {
    if (!row?.subscription_id) {
      return;
    }

    this.router.navigate(
      ["/dash/azure/billing", row.subscription_id, "resource-groups"],
      {
        queryParams: {
          month_year: row.month_year || this.monthYear,
          currency: row.currency || "",
        },
      }
    );
  }
}
